module.exports = __webpack_public_path__ + "static/ud_conversation-f4e629571952311d570152f305513223.svg";